@if (isLoading) {
<div id="loading-container">
    <nz-spin nzSimple nzSize="large"></nz-spin>
</div>
} @else {
<nz-card [nzTitle]="titleTemplate">
    <app-week-monitoringsheet-kpi [statusKpi]="statusKpi"></app-week-monitoringsheet-kpi>
</nz-card>
}

<ng-template #titleTemplate>
    <h3>{{ 'dashboard.monitoringKpiTitle' | translate }}</h3>
</ng-template>
<ng-template #extraTemplate>
    <h3 class="totalActionText">{{ 'dashboard.total' | translate }} : 0</h3>
</ng-template>